import svg11 from "../../assets/svg/svg11.svg";
import svg173 from "../../assets/svg/svg173.svg";
import svg174 from "../../assets/svg/svg174.svg";
import svg14 from "../../assets/svg/svg14.svg";

function Numbers() {
  const stats = [
    {
      id: 1,
      icon: svg11,
      label: "Speed",
      value: "Pay 1,000+ workers in minutes",
      description:
        "No delays, no queues, instant disbursement to mobile money & bank.",
    },
    {
      id: 2,
      icon: svg173,
      label: "Control",
      value: "Track every shilling in real time",
      description: "Know exactly where your money goes, no spreadsheets, no guesswork.",
    },
    {
      id: 3,
      icon: svg174,
      label: "Scale",
      value: "Built for teams of 10 to 10,000+",
      description:
        "From small crews to large operations, NdovuPay grows with you.",
    },
    {
      id: 4,
      icon: svg14,
      label: "Reliability",
      value: "Secure, accurate & always on",
      description: "Every transaction logged, verified, and auditable.",
    },
  ];

  return (
    <>
      <div className="flex items-center flex-col justify-center">
        <div className="flex items-center text-ndovuRed">
          <span className="w-[1.25rem] h-[0.09375rem]"></span>
          <span className="text-[1rem] font-[500] leading-[1.625rem] uppercase">
            Our numbers
          </span>
        </div>

        <div className="mt-[1rem] text-[#000] text-[1.75rem] md:text-[2.25rem] font-[500] leading-[2.625rem] max-w-full lg:max-w-[48rem] w-full text-center px-4">
        Trusted by Businesses That Can’t Afford Mistakes
        </div>
      </div>

      <div className="mt-[3.5rem] grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[1.5rem] lg:gap-[2.62rem]">
        {stats &&
          stats?.map((item) => (
            <div key={item.id} className="min-h-[17.1875rem] h-auto rounded-[1.25rem] bg-white numbers-card px-[1.5rem] md:px-[2rem] py-[2.5rem] border border-[#FBFBFE] flex flex-col">
              <div className="gap-[.5rem] flex items-center text-[#000] text-[1.125rem] font-[600] leading-[1.625rem]">
                <img src={item?.icon} alt={item?.icon} className="flex-shrink-0" /> {item?.label}
              </div>

              <div className="mt-[2.5rem] text-[#1E191B] text-[1.25rem] md:text-[1.5rem] font-[600] leading-[1.875rem]">
                {item?.value}
              </div>

              <div className="mt-[.75rem] text-[#7A7493] text-[.875rem] font-[400] leading-[1.5rem]">
                {item?.description}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default Numbers;
